export default __webpack_public_path__ + "static/media/guy--mobile@2x.e2bff00a.jpg";